var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
let ExEditorToolbarDividerElement = class ExEditorToolbarDividerElement extends LitElement {
    render() {
        return html `<span class="divider"></span>`;
    }
};
ExEditorToolbarDividerElement.styles = [
    css `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 16px;
      }
      .divider {
        box-sizing: border-box;
        display: block;
        height: 100%;
        border: 1px solid #d8d8d8;
      }
    `,
];
ExEditorToolbarDividerElement = __decorate([
    customElement('exeditor-toolbar-divider')
], ExEditorToolbarDividerElement);
export { ExEditorToolbarDividerElement };
//# sourceMappingURL=toolbar-divider.js.map